export const removeHtmlTags = (input: string) => {
    const htmlTagsRegex = /<\/?[^>]+(>|$)/g;
    return input.replace(htmlTagsRegex, '');
};
